import { useListLedgerAccounts, type AccountOut } from '@myrentalmate/api-client';
import { Stack, Typography } from '@mui/material';

import { DataTable, type DataColumn } from '../../components/DataTable';
import { okData } from '../../lib/apiData';

const TYPE_LABELS: Record<AccountOut['account_type'], string> = {
  asset: 'Asset',
  liability: 'Liability',
  equity: 'Equity',
  income: 'Income',
  expense: 'Expense',
};

const COLUMNS: DataColumn<AccountOut>[] = [
  { label: 'Code', render: (a) => a.code },
  { label: 'Account', render: (a) => a.name },
  { label: 'Type', render: (a) => TYPE_LABELS[a.account_type] },
];

export function AccountsPage() {
  const accounts = okData(useListLedgerAccounts().data)?.items ?? [];
  return (
    <Stack spacing={2}>
      <div>
        <Typography variant="h5">Chart of Accounts</Typography>
        <Typography color="text.secondary">The accounts your ledger posts to.</Typography>
      </div>
      <DataTable columns={COLUMNS} rows={accounts} rowKey={(a) => a.id} />
    </Stack>
  );
}
